import { Grid, Typography } from '@mui/material';
import { FormikHelpers } from 'formik';
import Layout from '../../../core/ui/layout/Layout';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';
import { parseValidationErrors } from '../../../core/utils/validation';
import { SuccessStoryCreate } from '../successStory';
import CreateSuccessStoryForm from '../components/CreateSuccessStoryForm';
import ReturnButton from '../../../core/ui/utility/ReturnButton';
import { parseFormQuery } from '../../../core/utils/utility';

const CreateSuccessStoryContainer = () => {
  const { callApi, loading: submitting } = useSendApiData();

  const handleSubmit = async (
    values: SuccessStoryCreate,
    { setFieldError }: FormikHelpers<SuccessStoryCreate>
  ) => {
    let success = false;

    const formData: any = parseFormQuery(values);

    await callApi({
      endpoint: 'auth-ea35a/success-stories',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onValidationError: (err) => parseValidationErrors(err, setFieldError),
      onError: toastError,
      onSuccess: async (_) => {
        toastMessage('SuccessStory Created');
        success = true;
      },
    });

    return success;
  };

  return (
    <Layout renderLeftToolbar={() => <ReturnButton to="/success-stories" />}>
      <Grid sx={{ p: 2 }}>
        <Grid container sx={{ mb: 2, px: 1 }}>
          <Typography variant="h5">Add SuccessStory</Typography>
        </Grid>
        <CreateSuccessStoryForm
          onSubmit={handleSubmit}
          submitting={submitting}
        />
      </Grid>
    </Layout>
  );
};

export default CreateSuccessStoryContainer;
